<template>
  <div id="tryoutgroup-form">
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>
        <router-link :to="{path: '/tryout-groups'}">Tryout Group</router-link>
      </li>
      <li class="active">Create</li>
    </ol>
    <!-- begin page-header -->
    <h1 class="page-header">Buat Tryout Group Baru</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div v-if="groupId" class="btn-group pull-right">
              <button v-if="!isPublished" type="button" class="btn btn-danger btn-xs" v-on:click="publishTryoutGroup()">Belum Publish</button>
              <button v-else type="button" class="btn btn-success btn-xs" v-on:click="unPublishTryoutGroup()">Terpublish</button>
            </div>
            <h4 class="panel-title">Buat Tryout Group</h4>
          </div>
          <div class="panel-body">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group">
                  <label class="col-md-2 control-label">Nama *</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" placeholder="Nama tryout group" v-model="name">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Kelas *</label>
                  <div class="col-md-8 col-xs-12">
                    <div v-for="item in 12" :key="item">
                      <input type="checkbox" v-model="grade" :value="item">
                      {{item}}
                      ({{ item <= 6 ? 'SD' : item > 6 && item < 10 ? 'SMP' : 'SMA'}})
                    </div>
                    
                    <!-- <input type="checkbox" v-model="grade" value="2"> 2 (SD) -->
                    <!-- {{item}} -->
                    <!-- <select v-model="grade" multiple>
                    <option :value="1">1 (SD)</option>
                    <option :value="2">2 (SD)</option>
                    <option :value="3">3 (SD)</option>
                      <option :value="4">4 (SD)</option>
                      <option :value="5">5 (SD)</option>
                      <option :value="6">6 (SD)</option>
                      <option :value="7">7 (SMP)</option>
                      <option :value="8">8 (SMP)</option>
                      <option :value="9">9 (SMP)</option>
                      <option :value="10">10 (SMA)</option>
                      <option :value="11">11 (SMA)</option>
                      <option :value="12">12 (SMA)</option>
                    </select> -->
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Deskripsi *</label>
                  <div class="col-md-8 col-xs-12">
                    <textarea class="form-control" placeholder="Deskripsi tryout group" v-model="description"></textarea>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Tipe *</label>
                  <div class="col-md-8 col-xs-12">
                    <select name="type" v-model="type">
                      <option value="SBMPTN">SBMPTN</option>
                      <option value="UJIAN_AKHIR_NASIONAL">UJIAN AKHIR NASIONAL</option>
                      <option value="UJIAN_AKHIR_SEKOLAH">UJIAN AKHIR SEKOLAH</option>
                      <option value="UJIAN_SEKOLAH">UJIAN SEKOLAH</option>
                      <option value="PENILAIAN_TENGAH_SEMESTER">Penilaian Tengah Semester (PTS)</option>
                      <option value="PENILAIAN_AKHIR_SEMESTER">Penilaian Akhir Semester (PAS)</option>
                      <option value="UJIAN_MANDIRI">Ujian Mandiri (UM)</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Varian *</label>
                  <div class="col-md-8 col-xs-12">
                    <select name="variant" v-model="variant">
                      <option value="SCHEDULED">BERAGENDA</option>
                      <option value="INSTANT_COMPLETE">INSTANT</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Sumber *</label>
                  <div class="col-md-8 col-xs-12">
                    <select name="variant" v-model="source_id">
                      <option value="">-</option>
                      <option :value="item.id" v-for="(item, index) in listTryoutSource" :key="index">{{ item.name }}</option>
                      <!-- <option value="INSTANT_COMPLETE">INSTANT</option> -->
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Pra-Syarat</label>
                  <div class="col-md-8 col-xs-12">
                    <app-tryoutgroupchooser :params="{grade: grade, status: 'PUBLISHED', type: type, variant: variant}"
                      v-on:dblClicked="addDependency($event)"></app-tryoutgroupchooser>
                    <br />
                    <div class="note note-info" v-if="$store.state.tryoutgroup.dependency_id">
                      <h4>{{dependencyName}}</h4>
                    </div>
                    <button v-if="$store.state.tryoutgroup.dependency_id" type="button" class="btn btn-danger" @click="showModal = true">hapus</button>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Options</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="checkbox" name="isSticky" v-model="isSticky"> Sticky <br />
                    <input type="checkbox" name="isPrivate" v-model="isPrivate"> Private
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Join Code (max 10 char, opsional)</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form form-control" :value="joinCode.toUpperCase()" @input="joinCode = $event.target.value.toUpperCase()" maxlength="10">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Tgl. Pembahasan Umum*</label>
                  <div class="col-md-8 col-xs-12">
                    <div class="row">
                      <div class="col-md-6 col-xs-12">
                        <div class="input-group">
                          <input id="discussionDate" v-model="discussionDate" type="text" class="form-control datepicker" placeholder="Tanggal Pembahasan Untuk Umum" name="discussion_date" readonly>
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-calendar"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                      <div class="col-md-6 col-xs-12">
                        <div class="input-group clockpicker">
                          <input id="discussionTime" v-model="discussionTime" type="text" class="form-control" placeholder="Jam : Menit" name="end_time" readonly>
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-clock-o"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Tgl. Pembahasan Siswa NF *</label>
                  <div class="col-md-8 col-xs-12">
                    <div class="row">
                      <div class="col-md-6 col-xs-12">
                        <div class="input-group">
                          <input id="discussionSpecialDate" v-model="discussionSpecialDate" type="text" class="form-control datepicker" placeholder="Tanggal Pembahasan Khusus Siswa NF" name="discussion_special_date" readonly>
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-calendar"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                      <div class="col-md-6 col-xs-12">
                        <div class="input-group clockpicker">
                          <input id="discussionSpecialTime" v-model="discussionSpecialTime" type="text" class="form-control" placeholder="Jam : Menit" name="end_special_time" readonly>
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-clock-o"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Mulai</label>
                  <div class="col-md-8 col-xs-12">
                    <div class="row" v-if="variant === 'SCHEDULED'">
                      <div class="col-md-6 col-xs-12">
                        <div class="input-group">
                          <input id="openedAtDate" v-model="openedAt" type="text" class="form-control datepicker" placeholder="Tanggal Dimulai Tryout" name="opened_at" readonly>
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-calendar"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                      <div class="col-md-6 col-xs-12">
                        <div class="input-group clockpicker">
                          <input id="openedAtTime" v-model="openedAtTime" type="text" class="form-control" placeholder="Jam : Menit" name="opened_at_time" readonly>
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-clock-o"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <span v-else>-</span>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Berakhir</label>
                  <div class="col-md-8 col-xs-12">
                    <div class="row" v-if="variant === 'SCHEDULED'">
                      <div class="col-md-6 col-xs-12">
                        <div class="input-group">
                          <input id="closedAtDate" v-model="closedAt" type="text" class="form-control datepicker" placeholder="Tanggal Berakhir Tryout" name="opened_at" readonly>
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-calendar"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                      <div class="col-md-6 col-xs-12">
                        <div class="input-group clockpicker">
                          <input id="closedAtTime" v-model="closedAtTime" type="text" class="form-control" placeholder="Jam : Menit" name="end_special_time" readonly>
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-clock-o"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <span v-else>-</span>
                  </div>
                </div>
                <div class="form-group" v-if="groupId">
                  <label class="col-md-2 control-label">Tryout</label>
                  <div class="col-md-8 col-xs-12">
                    <app-tryoutchooser v-on:selected="addTryoutIntoGroup($event)" :isInstant="$store.state.tryoutgroup.variant !== 'SCHEDULED'"></app-tryoutchooser><br />
                    <table class="table table-hover">
                      <thead>
                      <tr>
                        <th>Nama Tryout</th>
                        <th>Tipe</th>
                        <th>Kategori</th>
                        <th>Mata Pelajaran</th>
                        <th>Action</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(tryout, index) in tryouts" v-bind:key="index">
                        <td>{{ tryout.name }}</td>
                        <td>{{ tryout.type }}</td>
                        <td>{{ tryout.category }}</td>
                        <td>
                          <span v-for="(subtest, index) in tryout.subtests" v-bind:key="index">{{ subtest.subject_name }},</span>
                        </td>
                        <td><button class="btn btn-danger btn-xs" v-on:click="removeTryoutFromGroup(tryout)">Hapus</button></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </form>
            <hr />
            <div class="pull-right"><button type="button" class="btn btn-success pull-right" @click="saveTryoutGroup()">Simpan</button></div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
    <app-modal v-if="showModal" :withCancel="true" v-on:ok="removeDependency()" v-on:cancel="showModal = false">
      <h4 slot="header">Hapus Pra-Syarat</h4>
      <div slot="body">Apakah anda yakin akan menghapus pra-syarat <strong style="color: red">{{dependencyName}}</strong> ?</div>
    </app-modal>
  </div>
</template>

<script>
import TryoutChooser from '@/components/tryout_group/TryoutChooser'
import TryoutGroupChooser from '@/components/tryout_group/TryoutGroupChooser'
import Spinner from '@/components/plugins/Spinner'
import Modal from '@/components/plugins/Modal'
import TryoutService from '@/services/tryout.js'
import Moment, { now } from 'moment'

export default {
  name: 'tryoutgroup-form',
  components: {
    'app-tryoutchooser': TryoutChooser,
    'app-tryoutgroupchooser': TryoutGroupChooser,
    'app-spinner': Spinner,
    'app-modal': Modal
  },
  data: function () {
    return {
      discussionDate: null,
      discussionTime: null,
      discussionSpecialDate: null,
      discussionSpecialTime: null,
      openedAt: null,
      openedAtTime: null,
      closedAt: null,
      closedAtTime: null,
      isLoading: false,
      showModal: false,
      dependencyName: '',
      listTryoutSource: [],
      errors: []
    }
  },
  computed: {
    isPublished: function () {
      return this.$store.state.tryoutgroup.status == 'PUBLISHED'
    },
    groupId: function () {
      return this.$store.state.tryoutgroup.id
    },
    name: {
      get: function () {
        return this.$store.state.tryoutgroup.name
      },
      set: function (value) {
        this.$store.commit('tryout_group_set_name', value)
      }
    },
    description: {
      get: function () {
        return this.$store.state.tryoutgroup.description
      },
      set: function (value) {
        this.$store.commit('tryout_group_set_description', value)
      }
    },
    type: {
      get: function () {
        return this.$store.state.tryoutgroup.type
      },
      set: function (value) {
        this.$store.commit('tryout_group_set_type', value)
      }
    },
    variant: {
      get: function () {
        return this.$store.state.tryoutgroup.variant
      },
      set: function (value) {
        this.$store.commit('tryout_group_set_variant', value)
      }
    },
    source_id: {
      get: function () {
        return this.$store.state.tryoutgroup.source_id
      },
      set: function (value) {
        this.$store.commit('tryout_group_set_source_id', value)
      }
    },
    grade: {
      get: function () {
        return this.$store.state.tryoutgroup.grade
      },
      set: function (value) {
        this.$store.commit('tryout_group_set_grade', value)
      }
    },
    joinCode: {
      get: function () {
        return this.$store.state.tryoutgroup.joinCode
      },
      set: function (value) {
        this.$store.commit('tryout_group_set_join_code', value)
      }
    },
    isPrivate: {
      get: function () {
        return this.$store.state.tryoutgroup.isPrivate
      },
      set: function (value) {
        this.$store.commit('tryout_group_set_is_private', value)
      }
    },
    isSticky: {
      get: function () {
        return this.$store.state.tryoutgroup.isSticky
      },
      set: function (value) {
        this.$store.commit('tryout_group_set_is_sticky', value)
      }
    },
    tryouts: function () {
      return this.$store.state.tryoutgroup.tryouts
    },
    // openedAt: {
    //   get: function () {
    //     var time = this.$store.getters.openedAt
    //     return time > 0 ? Moment(time).format('DD/MM/YYYY') : '-'
    //   },
    //   set: function (value) {
    //     var time = value
    //     console.log(value)
    //     return time > 0 ? Moment(time).format('DD/MM/YYYY') : '-'
    //   }
    // },
    // openedAtTime: {
    //   get: function () {
    //     var time = this.$store.getters.openedAt
    //     return time > 0 ? Moment(time).format('HH:mm') : '-'
    //   },
    //   set: function (value) {
    //     var time = value
    //     console.log(value)
    //     return time > 0 ? Moment(time).format('HH:mm') : '-'
    //   }
    // },
    // closedAt: {
    //   get: function () {
    //     var time = this.$store.getters.closedAt
    //     return time > 0 ? Moment(time).format('DD/MM/YYYY') : '-'
    //   },
    //   set: function (value) {
    //     var time = value
    //     return time > 0 ? Moment(time).format('DD/MM/YYYY') : '-'
    //   }
    // },
    // closedAtTime: {
    //   get: function () {
    //     var time = this.$store.getters.closedAt
    //     return time > 0 ? Moment(time).format('HH:mm') : '-'
    //   },
    //   set: function (value) {
    //     var time = value
    //     return time > 0 ? Moment(time).format('HH:mm') : '-'
    //   }
    // }
  },
  methods: {
    addTryoutIntoGroup: function (tryout) {
      this.isLoading = true
      var context = this
      TryoutService.addTryoutIntoGroup(tryout.id, this.groupId, function (result) {
        if (result.success) {
          context.$store.commit('tryout_group_add_tryout', result.data)
        }

        context.isLoading = false
      })
    },
    removeTryoutFromGroup: function (tryout) {
      var context = this
      var confirmed = window.confirm("Apakah anda yakin akan melepas tryout ini?")

      if (confirmed) {
        this.isLoading = true
        TryoutService.removeTryoutFromGroup(tryout.id, this.groupId, function (result) {
          if (result.success) {
            context.$store.commit('tryout_group_remove_tryout', result.data)
          }

          context.isLoading = false
        })
      }
    },
    saveTryoutGroup: function () {
      if (!this.validateForm()) {
        return
      }

      this.isLoading = true
      var context = this
      var timestamp = this.discussionDate + " " + this.discussionTime
      var discussionOpenedAt = Moment(timestamp, "DD/MM/YYYY HH:mm").valueOf()

      
      var timestampSpecial = this.discussionSpecialDate + " " + this.discussionSpecialTime
      var discussionSpecialAt = Moment(timestampSpecial, "DD/MM/YYYY HH:mm").valueOf()

      var timestampOpened = this.openedAt + " " + this.openedAtTime
      var customedOpenedAt = Moment(timestampOpened, "DD/MM/YYYY HH:mm").valueOf()

      var timestampClosed = this.closedAt + " " + this.closedAtTime
      var customedClosedAt = Moment(timestampClosed, "DD/MM/YYYY HH:mm").valueOf()
      

      var tryoutGroup = {
        name: this.$store.state.tryoutgroup.name,
        description: this.$store.state.tryoutgroup.description,
        type: this.$store.state.tryoutgroup.type,
        variant: this.$store.state.tryoutgroup.variant,
        discussion_opened_at: discussionOpenedAt,
        discussion_special_at: discussionSpecialAt,
        grades: this.$store.state.tryoutgroup.grade,
        join_code: this.$store.state.tryoutgroup.joinCode,
        is_sticky: this.$store.state.tryoutgroup.isSticky,
        is_private: this.$store.state.tryoutgroup.isPrivate,
        dependency_id: this.$store.state.tryoutgroup.dependency_id,
        source_id: this.$store.state.tryoutgroup.source_id,
        opened_at: customedOpenedAt,
        closed_at: customedClosedAt
      }

      var groupId = this.$store.state.tryoutgroup.id
      if (groupId) {
        TryoutService.editTryoutGroup(groupId, tryoutGroup, function (result) {
          context.isLoading = false
        })
      } else {
        TryoutService.createTryoutGroup(tryoutGroup, function (result) {
          if (result.success) {
            window.alert("Tryout Group berhasil dibuat :)")
            context.$store.commit('tryout_group_set_id', result.data.id)
          }
          context.isLoading = false
        })
      }
    },
    publishTryoutGroup: function () {
      /**
       * di takeout karena ada request dari pak gatra biar bisa edit dan publish tryout
       * dadakan walaupun masa tryout sudah dimulai (untuk tryout coba-coba)
       *
      if (this.checkIfTryoutGroupIsOnGoing()) {
        window.alert('Tidak dapat mem-publish tryout group yang sudah lewat waktu mulainya')
        return
      }
      **/

      // if (this.checkIfTryoutGroupIsExpired()) {
      //   window.alert('Tidak dapat mem-publish tryout group yang sudah lewat waktu berakhirnya')
      //   return
      // }

      var tryoutCount = this.$store.state.tryoutgroup.tryouts.length
      if (tryoutCount == 0) {
        window.alert("Tidak dapat publish tryout group kosong")
        return
      }

      var confirmed = window.confirm("Apakah anda yakin akan PUBLISH group ini?")
      if (confirmed) {
        this.isLoading = true
        var context = this
        TryoutService.publishTryoutGroup(this.groupId, function (result) {
          if (result.success) {
            context.$store.commit('tryout_group_set_status', result.data.status)
          }

          context.isLoading = false
        })
      }
    },
    unPublishTryoutGroup: function () {
      // if (this.checkIfTryoutGroupIsOnGoing()) {
      //   window.alert('Tidak dapat mengubah status group tryout yang sedang berlangsung')
      //   return
      // }

      var confirmed = window.confirm('Apakah anda yakin akan mengembalikan group ini ke DRAFT?')
      if (confirmed) {
        this.isLoading = true
        var context = this
        TryoutService.unPublishTryoutGroup(this.groupId, function (result) {
          if (result.success) {
            context.$store.commit('tryout_group_set_status', result.data.status)
          }

          context.isLoading = false
        })
      }
    },
    checkIfTryoutGroupIsOnGoing: function () {
      if (this.variant !== 'SCHEDULED') return false

      var startTime = this.$store.getters.openedAt
      var endTime = this.$store.getters.closedAt
      var nowTime = new Date().valueOf()

      return nowTime > startTime && nowTime < endTime
    },
    checkIfTryoutGroupIsExpired: function () {
      if (this.variant !== 'SCHEDULED') return false

      var endTime = this.$store.getters.closedAt
      var nowTime = new Date().valueOf()

      return nowTime > endTime
    },
    validateForm: function () {
      this.errors = []
      if (this.name == '') this.errors.push('Nama wajib diisi')
      if (this.description == '') this.errors.push('Deskripsi wajib diisi')
      if (this.discussionDate == null) this.errors.push('Tanggal pembahasan untuk umum wajib diisi')
      if (this.discussionTime == null) this.errors.push('Waktu pembahasan untuk umum wajib diisi')
      if (this.discussionSpecialDate == null) this.errors.push('Tanggal pembahasan untuk siswa NF wajib diisi')
      if (this.discussionSpecialTime == null) this.errors.push('Waktu pembahasan untuk siswa NF wajib diisi')

      return this.errors.length == 0
    },
    addDependency: function (group) {
      this.dependencyName = group.data[0]
      this.$store.commit('tryout_group_set_dependency_id', group.id)
    },
    removeDependency: function () {
      this.showModal = false
      this.dependencyName = ''
      this.$store.commit('tryout_group_set_dependency_id', null)
    },
    getTryoutListSource(){
      let context = this
      TryoutService.listTryoutSource(function (result) {
          if (result.success) {
            // context.$store.commit('tryout_group_set_status', result.data.status)
            // console.log(result)
            context.listTryoutSource = result.data
          }

          context.isLoading = false
        })
        // console.log(context.$route)
      TryoutService.getTryoutGroup(context.$route.query.id, function (result) {
        if (result.success) {
          var tryoutGroup = result.data
          context.$store.commit('tryout_group_init', tryoutGroup)
          // context.$router.push({ path: '/tryout-group/form', query: { id: groupId } })
        }
      })
    },
  },
  mounted: function () {
    var context = this
    this.getTryoutListSource()
    DatepickerPlugin.init("#discussionDate", function (value) {
      context.discussionDate = value
    })

    ClockpickerPlugin.init("#discussionTime", function (value) {
      context.discussionTime = value
    })

    DatepickerPlugin.init("#discussionSpecialDate", function (value) {
      context.discussionSpecialDate = value
    })

    ClockpickerPlugin.init("#discussionSpecialTime", function (value) {
      context.discussionSpecialTime = value
    })

    DatepickerPlugin.init("#openedAtDate", function (value) {
      context.openedAt = value
    })

    ClockpickerPlugin.init("#openedAtTime", function (value) {
      context.openedAtTime = value
    })

    DatepickerPlugin.init("#closedAtDate", function (value) {
      context.closedAt = value
    })

    ClockpickerPlugin.init("#closedAtTime", function (value) {
      context.closedAtTime = value
    })


    
    if (this.$route.query.id) {
      // console.log(this.$store.state.tryoutgroup)
      var timestampMilis = this.$store.state.tryoutgroup.discussion_opened_at
      this.discussionDate = Moment(timestampMilis).format('DD/MM/YYYY')
      this.discussionTime = Moment(timestampMilis).format('HH:mm')

      var timestampMilisSpecial = this.$store.state.tryoutgroup.discussion_special_at
      this.discussionSpecialDate = Moment(timestampMilisSpecial).format('DD/MM/YYYY')
      this.discussionSpecialTime = Moment(timestampMilisSpecial).format('HH:mm')

      var timestampMilisOpenedAt = this.$store.state.tryoutgroup.opened_at
      this.openedAt = Moment(timestampMilisOpenedAt).format('DD/MM/YYYY')
      this.openedAtTime = Moment(timestampMilisOpenedAt).format('HH:mm')

      var timestampMilisClosedAt = this.$store.state.tryoutgroup.closed_at
      this.closedAt = Moment(timestampMilisClosedAt).format('DD/MM/YYYY')
      this.closedAtTime = Moment(timestampMilisClosedAt).format('HH:mm')


      if (this.$store.state.tryoutgroup.dependency_id) {
        var context = this
        var groupId = this.$store.state.tryoutgroup.dependency_id
        TryoutService.getTryoutGroup(groupId, function (response) {
          context.dependencyName = response.data.name
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?d4281b6c